import { useCallback } from "react";
import { DefaultFetchError, useFetchGetId } from "../hooks/fetch";

interface ExportParams {
  vaadId?: string;
}

export function useUsersExportDownload() {
  const exportFetch = useFetchGetId<Blob, DefaultFetchError, ExportParams>(
    "users/export",
    "",
    {
      autoStart: false,
      startStateLoading: false,
    },
    "blob",
  );

  const download = useCallback(
    async (params: ExportParams) => {
      const result = await exportFetch.fetch(params);

      if (!result || exportFetch.error) {
        throw exportFetch.error || new Error("Download failed");
      }

      const blob = result;
      const blobUrl = window.URL.createObjectURL(blob);

      const contentDisposition =
        exportFetch.response?.headers?.["content-disposition"];
      const filenameMatch = contentDisposition?.match(
        /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
      );
      const filename =
        filenameMatch?.[1]?.replace(/['"]/g, "") || "users-export.xlsx";

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    },
    [exportFetch],
  );

  return {
    download,
    loading: exportFetch.loading,
    error: exportFetch.error,
  };
}
